import Metrix from "./metrix";

const APP_ID = "vuxwdjhawdxszsk";
const REGISTER_SUCCESSFULLY = "kfwqj";
const PASS_SEJAM_SUCCESSFULLY = "ngqyd";
const ENABLE_RECURRING = "gvkhg";

const metrix = Metrix.initialize({
  appId: APP_ID,
});

metrix.setUserIdListener((id) => {
  console.log(id);
});
metrix.setSessionIdListener((id) => {
  console.log(id);
});

export const sendRegisterSuccessfully = () => {
  metrix.sendEvent(REGISTER_SUCCESSFULLY);
};

export const sendEnableRecurring = () => {
  metrix.sendEvent(ENABLE_RECURRING);
};

export const sendPassSejamSuccessfully = (attribute) => {
  metrix.sendEvent(PASS_SEJAM_SUCCESSFULLY, attribute);
};
